<template>
  <video-player
    class="kf-video"
    :options="{
      sources: [{ type: 'application/x-mpegurl', src: this.src }],
      autoplay: this.autoplay,
      poster: this.poster,
      muted: this.muted,
      controls: this.controls,
      preload: this.preload,
      fluid: this.fluid,
      loop: this.loop
    }"
    :playsinline="true"
  />
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player/src";
import "videojs-contrib-hls";

export default {
  data() {
    return {};
  },
  props: {
    // 视频地址
    src: {
      type: String,
      required: true
    },
    // 封面
    poster: String,
    // 静音
    muted: Boolean,
    // 自动播放
    autoplay: Boolean,
    // 操作栏
    controls: Boolean,
    // 自动加载
    preload: Boolean,
    // 尺寸自适应
    fluid: Boolean,
    // 循环
    loop: Boolean
  },
  components: { videoPlayer },
  mounted() {},
  methods: {}
};
</script>
<style lang="less"></style>
